/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { PfkRegionState } from "../models/pfk-region-state";
import { PfkIndustrySector } from "../models/pfk-industry-sector";
import { PfkOccupationMajorGroup } from "../models/pfk-occupation-major-group";
import { PreFilterKeysModel } from "../models/pre-filter-keys-model";
import { UdPreFilteredInteractives } from "../models/ud-pre-filtered-interactives";
import { UpdateSharingStatus } from "../models/update-sharing-status";
import { PreFilterHierarchyMaps } from "../models/pre-filter-hierarchy-maps";
import { PreFilterKeys } from "../models/pre-filter-keys";
import { PreFilterKeyValues } from "../models/pre-filter-key-values";
@Injectable({
  providedIn: "root",
})
class PreFilterInteractivesService extends __BaseService {
  static readonly preFilterInteractivesGetPreFilterRegionValuesPath =
    "/api/PreFilterInteractives/GetPreFilterRegionValues";
  static readonly preFilterInteractivesGetPreFilterIndustriesValuesPath =
    "/api/PreFilterInteractives/GetPreFilterIndustryValues";
  static readonly preFilterInteractivesGetPreFilterOccupationValuesPath =
    "/api/PreFilterInteractives/GetPreFilterOccupationValues";
  static readonly preFilterInteractivesGetInteractivePreFilterKeysPath =
    "/api/PreFilterInteractives/GetInteractivePreFilterKeys";
  static readonly preFilterInteractivesGetSubscriptionPreFilterInteractivesPath =
    "/api/PreFilterInteractives/GetSubscriptionPreFilterInteractives";
  static readonly preFilterInteractivesGetSubscriptionPreFilterInteractivePath =
    "/api/PreFilterInteractives/GetSubscriptionPreFilterInteractive";
  static readonly preFilterInteractivesCreatePreFilterInteractivePath =
    "/api/PreFilterInteractives/CreatePreFilterInteractive";
  static readonly preFilterInteractivesUpdatePreFilterInteractivePath =
    "/api/PreFilterInteractives/UpdatePreFilterInteractive";
  static readonly preFilterInteractivesDeletePreFilterInteractivePath =
    "/api/PreFilterInteractives/DeletePreFilterInteractive";
  static readonly preFilterInteractivesUpdatePreFilterInteractiveSharingPath =
    "/api/PreFilterInteractives/UpdatePreFilterInteractiveSharing";
  static readonly preFilterInteractivesAddFlatPreFilterKeyPath =
    "/api/PreFilterInteractives/AddFlatPreFilterKey";
  static readonly preFilterInteractivesAddHierarchPreFilterKeyPath =
    "/api/PreFilterInteractives/AddHierarchyPreFilterKey";
  static readonly preFilterInteractivesAddKeywordPreFilterKeyPath =
    "/api/PreFilterInteractives/AddKeywordPreFilterKey";
  static readonly preFilterInteractivesUpdateFlatPreFilterKeyPath =
    "/api/PreFilterInteractives/UpdatePreFilterKey";
  static readonly preFilterInteractivesDeletePreFilterKeyPath =
    "/api/PreFilterInteractives/DeletePreFilterKey";
  static readonly preFilterInteractivesUpdatePreFilterKeyValuesPath =
    "/api/PreFilterInteractives/UpdatePreFilterKeyValues";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  preFilterInteractivesGetPreFilterRegionValuesResponse(): __Observable<
    __StrictHttpResponse<Array<PfkRegionState>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilterInteractives/GetPreFilterRegionValues`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PfkRegionState>>;
      })
    );
  }
  preFilterInteractivesGetPreFilterRegionValues(): __Observable<
    Array<PfkRegionState>
  > {
    return this.preFilterInteractivesGetPreFilterRegionValuesResponse().pipe(
      __map((_r) => _r.body as Array<PfkRegionState>)
    );
  }
  preFilterInteractivesGetPreFilterIndustriesValuesResponse(): __Observable<
    __StrictHttpResponse<Array<PfkIndustrySector>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilterInteractives/GetPreFilterIndustryValues`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PfkIndustrySector>>;
      })
    );
  }
  preFilterInteractivesGetPreFilterIndustriesValues(): __Observable<
    Array<PfkIndustrySector>
  > {
    return this.preFilterInteractivesGetPreFilterIndustriesValuesResponse().pipe(
      __map((_r) => _r.body as Array<PfkIndustrySector>)
    );
  }
  preFilterInteractivesGetPreFilterOccupationValuesResponse(): __Observable<
    __StrictHttpResponse<Array<PfkOccupationMajorGroup>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilterInteractives/GetPreFilterOccupationValues`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PfkOccupationMajorGroup>>;
      })
    );
  }
  preFilterInteractivesGetPreFilterOccupationValues(): __Observable<
    Array<PfkOccupationMajorGroup>
  > {
    return this.preFilterInteractivesGetPreFilterOccupationValuesResponse().pipe(
      __map((_r) => _r.body as Array<PfkOccupationMajorGroup>)
    );
  }

  /**
   * @param interactiveId undefined
   */
  preFilterInteractivesGetInteractivePreFilterKeysResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<PreFilterKeysModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilterInteractives/GetInteractivePreFilterKeys`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterKeysModel>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  preFilterInteractivesGetInteractivePreFilterKeys(
    interactiveId?: number
  ): __Observable<Array<PreFilterKeysModel>> {
    return this.preFilterInteractivesGetInteractivePreFilterKeysResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<PreFilterKeysModel>));
  }

  /**
   * @param subscriptionId undefined
   */
  preFilterInteractivesGetSubscriptionPreFilterInteractivesResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<UdPreFilteredInteractives>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/PreFilterInteractives/GetSubscriptionPreFilterInteractives`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UdPreFilteredInteractives>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  preFilterInteractivesGetSubscriptionPreFilterInteractives(
    subscriptionId?: number
  ): __Observable<Array<UdPreFilteredInteractives>> {
    return this.preFilterInteractivesGetSubscriptionPreFilterInteractivesResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as Array<UdPreFilteredInteractives>));
  }

  /**
   * @param preFilterInteractiveId undefined
   */
  preFilterInteractivesGetSubscriptionPreFilterInteractiveResponse(
    preFilterInteractiveId?: number
  ): __Observable<__StrictHttpResponse<UdPreFilteredInteractives>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterInteractiveId != null)
      __params = __params.set(
        "preFilterInteractiveId",
        preFilterInteractiveId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/PreFilterInteractives/GetSubscriptionPreFilterInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UdPreFilteredInteractives>;
      })
    );
  }
  /**
   * @param preFilterInteractiveId undefined
   */
  preFilterInteractivesGetSubscriptionPreFilterInteractive(
    preFilterInteractiveId?: number
  ): __Observable<UdPreFilteredInteractives> {
    return this.preFilterInteractivesGetSubscriptionPreFilterInteractiveResponse(
      preFilterInteractiveId
    ).pipe(__map((_r) => _r.body as UdPreFilteredInteractives));
  }

  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesCreatePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterInteractive`:
   *
   * - `subscriptionId`:
   */
  preFilterInteractivesCreatePreFilterInteractiveResponse(
    params: PreFilterInteractivesService.PreFilterInteractivesCreatePreFilterInteractiveParams
  ): __Observable<__StrictHttpResponse<UdPreFilteredInteractives>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.preFilterInteractive;
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/CreatePreFilterInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UdPreFilteredInteractives>;
      })
    );
  }
  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesCreatePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterInteractive`:
   *
   * - `subscriptionId`:
   */
  preFilterInteractivesCreatePreFilterInteractive(
    params: PreFilterInteractivesService.PreFilterInteractivesCreatePreFilterInteractiveParams
  ): __Observable<UdPreFilteredInteractives> {
    return this.preFilterInteractivesCreatePreFilterInteractiveResponse(
      params
    ).pipe(__map((_r) => _r.body as UdPreFilteredInteractives));
  }

  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterInteractive`:
   *
   * - `subscriptionId`:
   */
  preFilterInteractivesUpdatePreFilterInteractiveResponse(
    params: PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveParams
  ): __Observable<__StrictHttpResponse<UdPreFilteredInteractives>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.preFilterInteractive;
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/UpdatePreFilterInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UdPreFilteredInteractives>;
      })
    );
  }
  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterInteractive`:
   *
   * - `subscriptionId`:
   */
  preFilterInteractivesUpdatePreFilterInteractive(
    params: PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveParams
  ): __Observable<UdPreFilteredInteractives> {
    return this.preFilterInteractivesUpdatePreFilterInteractiveResponse(
      params
    ).pipe(__map((_r) => _r.body as UdPreFilteredInteractives));
  }

  /**
   * @param preFilterInteractiveId undefined
   */
  preFilterInteractivesDeletePreFilterInteractiveResponse(
    preFilterInteractiveId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterInteractiveId != null)
      __params = __params.set(
        "preFilterInteractiveId",
        preFilterInteractiveId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/DeletePreFilterInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param preFilterInteractiveId undefined
   */
  preFilterInteractivesDeletePreFilterInteractive(
    preFilterInteractiveId?: number
  ): __Observable<boolean> {
    return this.preFilterInteractivesDeletePreFilterInteractiveResponse(
      preFilterInteractiveId
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `preFilterInteractiveId`:
   */
  preFilterInteractivesUpdatePreFilterInteractiveSharingResponse(
    params: PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.preFilterInteractiveId != null)
      __params = __params.set(
        "preFilterInteractiveId",
        params.preFilterInteractiveId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/PreFilterInteractives/UpdatePreFilterInteractiveSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `preFilterInteractiveId`:
   */
  preFilterInteractivesUpdatePreFilterInteractiveSharing(
    params: PreFilterInteractivesService.PreFilterInteractivesUpdatePreFilterInteractiveSharingParams
  ): __Observable<boolean> {
    return this.preFilterInteractivesUpdatePreFilterInteractiveSharingResponse(
      params
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesAddFlatPreFilterKeyParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `interactiveId`:
   *
   * - `daxName`:
   */
  preFilterInteractivesAddFlatPreFilterKeyResponse(
    params: PreFilterInteractivesService.PreFilterInteractivesAddFlatPreFilterKeyParams
  ): __Observable<__StrictHttpResponse<PreFilterKeysModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    if (params.daxName != null)
      __params = __params.set("daxName", params.daxName.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/AddFlatPreFilterKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterKeysModel>;
      })
    );
  }
  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesAddFlatPreFilterKeyParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `interactiveId`:
   *
   * - `daxName`:
   */
  preFilterInteractivesAddFlatPreFilterKey(
    params: PreFilterInteractivesService.PreFilterInteractivesAddFlatPreFilterKeyParams
  ): __Observable<PreFilterKeysModel> {
    return this.preFilterInteractivesAddFlatPreFilterKeyResponse(params).pipe(
      __map((_r) => _r.body as PreFilterKeysModel)
    );
  }

  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesAddHierarchPreFilterKeyParams` containing the following parameters:
   *
   * - `maps`:
   *
   * - `name`:
   *
   * - `interactiveId`:
   *
   * - `daxName`:
   */
  preFilterInteractivesAddHierarchPreFilterKeyResponse(
    params: PreFilterInteractivesService.PreFilterInteractivesAddHierarchPreFilterKeyParams
  ): __Observable<__StrictHttpResponse<PreFilterKeysModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.maps;
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    if (params.daxName != null)
      __params = __params.set("daxName", params.daxName.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/AddHierarchyPreFilterKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterKeysModel>;
      })
    );
  }
  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesAddHierarchPreFilterKeyParams` containing the following parameters:
   *
   * - `maps`:
   *
   * - `name`:
   *
   * - `interactiveId`:
   *
   * - `daxName`:
   */
  preFilterInteractivesAddHierarchPreFilterKey(
    params: PreFilterInteractivesService.PreFilterInteractivesAddHierarchPreFilterKeyParams
  ): __Observable<PreFilterKeysModel> {
    return this.preFilterInteractivesAddHierarchPreFilterKeyResponse(
      params
    ).pipe(__map((_r) => _r.body as PreFilterKeysModel));
  }

  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesAddKeywordPreFilterKeyParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `interactiveId`:
   *
   * - `daxName`:
   */
  preFilterInteractivesAddKeywordPreFilterKeyResponse(
    params: PreFilterInteractivesService.PreFilterInteractivesAddKeywordPreFilterKeyParams
  ): __Observable<__StrictHttpResponse<PreFilterKeysModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    if (params.daxName != null)
      __params = __params.set("daxName", params.daxName.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/AddKeywordPreFilterKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterKeysModel>;
      })
    );
  }
  /**
   * @param params The `PreFilterInteractivesService.PreFilterInteractivesAddKeywordPreFilterKeyParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `interactiveId`:
   *
   * - `daxName`:
   */
  preFilterInteractivesAddKeywordPreFilterKey(
    params: PreFilterInteractivesService.PreFilterInteractivesAddKeywordPreFilterKeyParams
  ): __Observable<PreFilterKeysModel> {
    return this.preFilterInteractivesAddKeywordPreFilterKeyResponse(
      params
    ).pipe(__map((_r) => _r.body as PreFilterKeysModel));
  }

  /**
   * @param preFilterKey undefined
   */
  preFilterInteractivesUpdateFlatPreFilterKeyResponse(
    preFilterKey: PreFilterKeysModel
  ): __Observable<__StrictHttpResponse<PreFilterKeysModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterKey;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/UpdatePreFilterKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterKeysModel>;
      })
    );
  }
  /**
   * @param preFilterKey undefined
   */
  preFilterInteractivesUpdateFlatPreFilterKey(
    preFilterKey: PreFilterKeysModel
  ): __Observable<PreFilterKeysModel> {
    return this.preFilterInteractivesUpdateFlatPreFilterKeyResponse(
      preFilterKey
    ).pipe(__map((_r) => _r.body as PreFilterKeysModel));
  }

  /**
   * @param preFilterKey undefined
   */
  preFilterInteractivesDeletePreFilterKeyResponse(
    preFilterKey: PreFilterKeys
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterKey;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/DeletePreFilterKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param preFilterKey undefined
   */
  preFilterInteractivesDeletePreFilterKey(
    preFilterKey: PreFilterKeys
  ): __Observable<boolean> {
    return this.preFilterInteractivesDeletePreFilterKeyResponse(
      preFilterKey
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * @param preFilterKeyId undefined
   */
  preFilterInteractivesUpdatePreFilterKeyValuesResponse(
    preFilterKeyId?: number
  ): __Observable<__StrictHttpResponse<Array<PreFilterKeyValues>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterKeyId != null)
      __params = __params.set("preFilterKeyId", preFilterKeyId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilterInteractives/UpdatePreFilterKeyValues`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterKeyValues>>;
      })
    );
  }
  /**
   * @param preFilterKeyId undefined
   */
  preFilterInteractivesUpdatePreFilterKeyValues(
    preFilterKeyId?: number
  ): __Observable<Array<PreFilterKeyValues>> {
    return this.preFilterInteractivesUpdatePreFilterKeyValuesResponse(
      preFilterKeyId
    ).pipe(__map((_r) => _r.body as Array<PreFilterKeyValues>));
  }
}

module PreFilterInteractivesService {
  /**
   * Parameters for PreFilterInteractivesCreatePreFilterInteractive
   */
  export interface PreFilterInteractivesCreatePreFilterInteractiveParams {
    preFilterInteractive: UdPreFilteredInteractives;
    subscriptionId?: number;
  }

  /**
   * Parameters for PreFilterInteractivesUpdatePreFilterInteractive
   */
  export interface PreFilterInteractivesUpdatePreFilterInteractiveParams {
    preFilterInteractive: UdPreFilteredInteractives;
    subscriptionId?: number;
  }

  /**
   * Parameters for PreFilterInteractivesUpdatePreFilterInteractiveSharing
   */
  export interface PreFilterInteractivesUpdatePreFilterInteractiveSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    preFilterInteractiveId?: number;
  }

  /**
   * Parameters for PreFilterInteractivesAddFlatPreFilterKey
   */
  export interface PreFilterInteractivesAddFlatPreFilterKeyParams {
    name?: null | string;
    interactiveId?: number;
    daxName?: null | string;
  }

  /**
   * Parameters for PreFilterInteractivesAddHierarchPreFilterKey
   */
  export interface PreFilterInteractivesAddHierarchPreFilterKeyParams {
    maps: Array<PreFilterHierarchyMaps>;
    name?: null | string;
    interactiveId?: number;
    daxName?: null | string;
  }

  /**
   * Parameters for PreFilterInteractivesAddKeywordPreFilterKey
   */
  export interface PreFilterInteractivesAddKeywordPreFilterKeyParams {
    name?: null | string;
    interactiveId?: number;
    daxName?: null | string;
  }
}

export { PreFilterInteractivesService };
